import bbva from '../../img/bancos/bbva.webp'
import bcp from '../../img/bancos/bcp.webp'
import interbank from '../../img/bancos/interbank.webp'
import scotiabank from '../../img/bancos/scotiabank.webp'
const LogoBank = ({name}) => <img className='img-logo-bank' src={
            name === "BCP" ? bcp :
            name === "BBVA" ? bbva :
            name === "Scotiabank" ? scotiabank :
            name === "Interbank" && interbank} alt="" />
export default LogoBank